import { FieldInputProps, useField } from "formik";
import * as React from "react";
import { TextInput, TextInputProps } from "..";

export type TextFieldProps = {
    id: string;
} & Partial<FieldInputProps<any>> &
    TextInputProps;

export const TextField = (props: TextFieldProps) => {
    const {
        name = props.id,
        checked,
        onChange,
        multiple,
        error,
        helperText,
        ...passthrough
    } = props;
    const [field, meta] = useField(name);
    const handleChange = React.useCallback(
        (e: React.ChangeEvent<any>) => {
            field.onChange(e);
            if (onChange) onChange(e);
        },
        [field, onChange]
    );

    const showError = !!meta.error;
    const errMsg = showError ? meta.error : undefined;

    const value =
        field.value === undefined || field.value === null ? "" : field.value;
    field.value = value;
    const { onBlur, onChange: fieldOnChange, ...fieldProps } = field;

    return (
        <TextInput
            {...passthrough}
            {...fieldProps}
            onChange={handleChange}
            error={showError}
            helperText={errMsg}
        />
    );
};
